import { api } from './configs/axiosConfigs';
import { prepareErr, defineCancelAPIObject } from './configs/axiosUtils';
import { notifier } from '../libs/notifier';

export const deckAPI = {
	getDecks: async function (cancel = false) {
		const url = '/decks';

		const response = await api
			.post(
				url,
				{},
				{
					signal: cancel ? cancelApiObject[this.getDecks.name].handleRequestCancellation().signal : undefined,
				}
			)
			.catch((error) => {
				return prepareErr(error);
			});

		if (response?.data?.status === 'success') {
			return {
				decks: response.data.decks,
			};
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return {
				decks: [],
			};
		}
	},

	addDeck: async function (name, note, cancel = false) {
		const url = 'decks/add';
		const formData = new FormData();
		formData.append('name', name);
		formData.append('note', note);

		const response = await api
			.post(url, formData, {
				signal: cancel ? cancelApiObject[this.addDeck.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response?.data?.status === 'success') {
			return {
				deck: response.data.deck,
			};
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return {};
		}
	},

	updateDeck: async function (deckId, name, note, lastStorageId, cancel = false) {
		const url = '/decks/update';
		const formData = new FormData();
		formData.append('deck_id', deckId);
		formData.append('name', name);
		formData.append('note', note);
		formData.append('last_storage_id', lastStorageId);

		const response = await api
			.post(url, formData, {
				signal: cancel ? cancelApiObject[this.updateDeck.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response?.data?.status === 'success') {
			return {
				deck: response.data.deck,
			};
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return null;
		}
	},

	deleteDeck: async function (deckId, cancel = false) {
		const url = '/decks/delete';
		const formData = new FormData();
		formData.append('id', deckId);

		const response = await api
			.post(url, formData, {
				signal: cancel ? cancelApiObject[this.deleteDeck.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response?.data?.status === 'success') {
			return true;
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return false;
		}
	},

	getDummies: async function (deckId, cancel = false) {
		const url = '/decks/dummies';
		const formData = new FormData();
		formData.append('deck_id', deckId);

		const response = await api
			.post(url, formData, {
				signal: cancel ? cancelApiObject[this.getDummies.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response?.data?.status === 'success') {
			return {
				dummies: response.data.dummies,
				samples: response.data.samples,
				cards: response.data.cards,
			};
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return null;
		}
	},

	addDummy: async function (deckId, cardId, placeholder, sampleId, cancel = false) {
		const url = '/decks/dummies/add';
		const formData = new FormData();
		formData.append('deck_id', deckId);
		formData.append('card_id', cardId);
		formData.append('placeholder', placeholder);
		formData.append('sample_id', sampleId);

		const response = await api
			.post(url, formData, {
				signal: cancel ? cancelApiObject[this.addDummy.name].handleRequestCancellation().signal : undefined,
			})
			.catch((error) => {
				return prepareErr(error);
			});

		if (response?.data?.status === 'success') {
			return response.data.dummy;
		} else {
			showAPIErr(url, response?.data?.message || 'Unspecified error');
			return null;
		}
	},
};

// Show formatted API error
const showAPIErr = (url, message) => {
	let errMsg = 'Error in deckAPI call ' + url + ' : ' + message;
	notifier.logToConsole(notifier.level.error, errMsg, true);
};

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelAPIObject(deckAPI);
